import { Observable } from "rxjs"
import { LogEntry } from "@core/classes"

export enum LogLevel {
  ALL = 0,
  DEBUG,
  INFO,
  WARN,
  ERROR,
  FATAL,
  APPLOGIN,
  APPLOGOUT,
  OFF
}

export interface BasicLogDetails {
  level: LogLevel,
  screen_route: string,
  log_event: string,
  log_message: string
}

export interface ExtendedLogDetails {
  jti?: string,
  user_id?: string,
  log_error?: string,
  request_endpoint?: string,
  request_data?: string,
  response_data?: string,
}

export interface DeviceLogDetails {
  browser: string,
  browser_version: string,
  device: string,
  device_type: string,
  orientation: string,
  os: string,
  os_version: string,
  userAgent: string,
}

export interface LogPublisher {
  location: string,
  log(logEntry: LogEntry, usingMobileDevice: boolean, token?: string, jti?: string): Observable<boolean>,
  clear(logEntry: LogEntry): Observable<boolean>
}

export interface WebAPILogData {
  user_id: string,
  screen_route?: string,
  log_event?: string,
  log_message: string
  jti?: string,
  log_error?: string,
  request_endpoint?: string,
  request_data?: string,
  response_data?: string,
  browser?: string,
  browser_version?: string,
  device?: string,
  device_type?: string,
  orientation?: string,
  os?: string,
  os_version?: string,
  userAgent?: string,
}
